import React from 'react'

import "./ArticleExcerpt.scss";

export interface IArticleExcerpt {
  paragraph: string;
}

const ArticleExcerpt = (props: IArticleExcerpt) => {
  let { paragraph } = props;
  return (
    <div className="m-article-excerpt">
      <div className="m-article-excerpt__content">
          <p className="m-article-excerpt__content-paragraph initial">
            {paragraph}
          </p>
      </div>
    </div>
  )
}

export default ArticleExcerpt
